export const environment = {
  production: true,
  apiUrl: 'https://klusdesign.pl/api',
  pageUrl: 'https://klusdesign.pl'
 };
//DirectoryIndex index.html